/**
 * Created by calhosh on 5/4/2023
 */
import React, {memo, useMemo} from 'react';
import {getBodyConfiguration} from './formBodyConfig.js';
import {GetCardTypeForBody} from '../../../../util/utils';
import {isEqual} from 'lodash';

function FormBodyItem({
	bodyElementId,
	headerId,
	sectionId,
	body,
	isSnapshotView,
	isDisabled,
	showEditTextResponse,
	setShowEditTextResponse,
	saveComplete,
	updateBodyOptions,
	getBodiesBySectionId,
	validations,
	documentId,
	documentRelatedTasks = [],
	formData
}) {
	const formBodyConfiguration = useMemo(() => getBodyConfiguration(body?.bodyTypeId), [body?.bodyTypeId]);

	const formBodyBorder = useMemo(() => GetCardTypeForBody(body), [body]);

	const formBodyRender = useMemo(() => {
		const extraProps = {
			isAresView: false,
			showGuidance: formBodyConfiguration?.showGuidance,
			showEditTextResponse: showEditTextResponse,
			setShowEditTextResponse: setShowEditTextResponse,
			saveComplete: saveComplete,
			updateBodyOptions: updateBodyOptions,
			validations: validations,
			documentId: documentId,
			documentRelatedTasks,
			formData
		};

		if (formBodyConfiguration && formBodyConfiguration.render) {
			return formBodyConfiguration.render(
				headerId,
				sectionId,
				body,
				isSnapshotView,
				isDisabled,
				extraProps,
				getBodiesBySectionId
			);
		}

		return null;
	}, [
		formBodyConfiguration,
		headerId,
		sectionId,
		body,
		isSnapshotView,
		isDisabled,
		getBodiesBySectionId,
		showEditTextResponse,
		setShowEditTextResponse,
		saveComplete,
		updateBodyOptions,
		validations,
		documentId,
		documentRelatedTasks,
		formData
	]);

	return (
		<section key={bodyElementId} id={bodyElementId} className={`bodyWrapper ${formBodyBorder}`}>
			{formBodyRender ? (
				formBodyRender
			) : (
				<section className={`FormBodyNameDetails ${formBodyBorder}`}>{body?.name}</section>
			)}
		</section>
	);
}

export default memo(FormBodyItem, isEqual);
